import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { commonTexts } from 'consts/text';
import { max300LengthRule } from 'consts/rules/textRules';

export const StreetAddressInputElement = ({ optional, ...props }: AppFormItemProps) => (
    <AppFormItem
        label={commonTexts.inputLabels.streetAddress}
        name={formFields.street}
        optional={optional}
        hasOptionalText={optional}
        rules={[max300LengthRule]}
        accessibilityLabel="Pole adres ulicy"
        {...props}
    >
        <AppInput
            autoComplete="street-address"
            accessibilityLabel="Pole adres ulicy"
            placeholder="Podaj adres ulicy"
        />
    </AppFormItem>
);
